<template>
        <div>
            <h3 style="text-align:center">{{ order_name }}</h3>
            <a-divider orientation="center">{{ $t('returnExchange.baseInfo') }}</a-divider>         
            <Form 
                class="returnForm" 
                :form="createReturnExchangeForm1"
                @handleInputNumber="handleInputNumber" 
                @handleSelectChange="handleSelectChange"
             ></Form>

            <a-divider orientation="center">{{ $t('returnExchange.returnInfo') }}</a-divider>
            <Form 
                class="returnForm" 
                :form="createReturnExchangeForm2" 
                @handleInputChange="handleInputChangeForm2" 
                @handleSelectChange="handleSelectChangeForm2"
                @handleSelectDate="handleSelectDate"
            ></Form>
            <Upload
                class="uploadImg"
                @changeUpload="changeUpload"
                @errorUpload="errorUpload"
            >
                <template #desc>
                    <div class="uploadDesc">{{ $t('returnExchange.uploadDesc') }}</div>
                </template>
            </Upload>

            <a-divider orientation="center" v-if="createReturnExchangeForm1.formData.type == 2">{{ $t('returnExchange.exchangeInfo') }}</a-divider>
            <Form 
                class="returnForm" 
                v-if="createReturnExchangeForm1.formData.type == 2" 
                :form="createReturnExchangeForm3"  
                @handleInputChange="handleInputChangeForm3" 
                @handleSelectChange="handleSelectChangeForm3"
            ></Form>

            <a-divider orientation="center">{{ $t('returnExchange.orderLineInfo') }}</a-divider>
            <!-- 调整弹窗宽度 -->
            <a-radio-group v-model="activeKey" type="button">
                <a-radio value="large" @click="handleWidth('large')">{{ $t('base.large')}}</a-radio>
                <a-radio value="medium" @click="handleWidth('medium')">{{ $t('base.medium')}}</a-radio>
                <a-radio value="small" @click="handleWidth('small')">{{ $t('base.small')}}</a-radio>
            </a-radio-group>
            
            <Table
                    class="deliverTable"
                    ref="tableRef"
                    :table="table"
                    @selectRow="selectRow"
                    @selectAllRow="selectRowAll"
                    @changePage="changeVersionPage"
                    @changePageSize="changeVersionPageSize"
            >
                <template v-slot:columns="{ props }"> 
                    <div v-if="props.column.key == 'frame_number'">
                        <div v-if="props.record.frame_number.length > 0">
                            <div v-for="(item,index) in props.record.frame_number" :key="index">{{ item.FRAME_NUMBER }}</div>
                        </div>
                        <div v-else>-</div>
                    </div>
                    <div v-if="props.column.key == 'swap_type'">
                        <a-select 
                            v-model="props.record.swap_type" 
                            :style="{width:'100px'}" 
                            @change="(val)=>changeSwapType(val,props.record)"
                        >
                            <a-option 
                                v-for="(item,index) in swapTypeOptions" 
                                :key="index" 
                                :disabled="(item.value == 1 && props.record.product_code != '627.501') || (item.value == 2 && props.record.product_code == '627.501')"
                            >
                                {{ item.label }}
                            </a-option>
                        </a-select>
                    </div>
                    <div v-if="props.column.key == 'back_quantity'">
                        <a-inputNumber 
                            v-model="props.record.back_quantity" 
                            :disabled="props.record.disabled" 
                            :style="{width:'80px'}" 
                            :min="0"
                            :max="9999"
                            :precision="0"
                            :hideButton="true"
                            :error="props.record.error"
                            @input="(val)=>quantityChange(val,props.record)"
                            @change="(val)=>quantityChange(val,props.record)"
                        />
                    </div>
                    <div v-if="props.column.key == 'swap_quantity'">
                        <a-inputNumber 
                            v-model="props.record.swap_quantity" 
                            :style="{width:'80px'}" 
                            allow-clear
                            :min="1"
                            :max="9999"
                            :precision="0"
                            :hideButton="true"
                        />
                    </div>
                    <div v-if="props.column.key == 'bom_category'">
                        <a-select 
                            v-model="props.record.bom_category" 
                            :style="{width:'250px'}" 
                            allow-search 
                            allow-clear
                            :disabled="props.record.bomDisabled"
                            @change="(val)=>changeBomCategory(val,props.record)"
                        >
                            <a-option v-for="(item,index) in bomCategoryOptions" :key="index">
                                {{ item.label }}
                            </a-option>
                        </a-select>
                    </div>
                    <div v-if="props.column.key == 'bom'">
                        <a-select 
                            v-model="props.record.bom" 
                            :style="{width:'250px'}" 
                            allow-search 
                            :loading="props.record.loading"
                            :disabled="props.record.bomDisabled"
                            @change="(val)=>changeBom(val,props.record)"
                        >
                            <a-option v-for="(item,index) in props.record.bomOptions" :key="index">
                                {{ item.label }}
                            </a-option>
                        </a-select>
                    </div>
                    <div v-if="props.column.key == 'swap_inventory_code'">
                        <a-select 
                            v-model="props.record.swap_inventory_code" 
                            :style="{width:'250px'}" 
                            allow-search 
                            :disabled="props.record.swapInventoryCodeDisabled"
                            @change="(val)=>changeInventoryCode(val,props.record)"
                        >
                            <a-option v-for="(item,index) in swapInventoryCodeOptions" :key="index">
                                {{ item.label }}
                            </a-option>
                        </a-select>
                    </div>
                    <div v-if="props.column.key == 'swap_inventory'">
                        <a-select 
                            v-model="props.record.swap_inventory" 
                            :style="{width:'250px'}" 
                            allow-search
                            @change="(val)=>changeInventory(val,props.record)"
                        >
                            <a-option v-for="(item,index) in swapInventoryOptions" :key="index" :disabled="item.disabled">
                                {{ item.label }}
                            </a-option>
                        </a-select>
                    </div>
                    <div v-if="props.column.key == 'instruction'">
                        <a-input 
                        :style="{width:'250px'}"
                        v-model="props.record.instruction" 
                        placeholder="Please enter something" 
                        allow-clear />
                    </div>
                </template>
            </Table>
        </div>  
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch, toRefs, h } from 'vue';
    import { OrderApi } from '@/api/OrderApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import Upload from '@/components/Upload.vue';
    import { CreateReturnExchangeForm1,CreateReturnExchangeForm2,CreateReturnExchangeForm3 } from './queryConfig/OrderListQuery.js';
    import { dateToTimestamp, timestampToDate } from '@/utils/index.js';
    import { useI18n } from 'vue-i18n';

    const props = defineProps({
        row:{
            type:Object,
            default:()=>{}
        },
        visible:{
            type:Boolean,
            default:false,
        }
    })

    const emits = defineEmits(['handleReturnWidth'])
    const { t } = useI18n()
    const tableRef = ref(null)
    const rowData = ref(null)
    const order_name =ref('')
    const createForm = reactive(null)
    const activeKey = ref('medium')
    const createReturnExchangeForm1 = reactive(CreateReturnExchangeForm1)
    const createReturnExchangeForm2 = reactive(CreateReturnExchangeForm2)
    const createReturnExchangeForm3 = reactive(CreateReturnExchangeForm3)
    const selected = ref([])
    const columns = ref([
            {
                // title: '出库单号',
                title:t('order.deliveryNumber'),
                dataIndex: 'delivery_number',
                key: 'delivery_number',
                width: '220',
                align: 'center',
                ellipsis:true,
                tooltip:true,
                show:true,
            },
            {
                // title: '产品名称',
                title:t('order.productName'),
                dataIndex: 'product_name',
                key: 'product_name',
                width: '150',
                align: 'center',
                ellipsis:true,
                tooltip:true,
                show:true,
            },
            {
                // title: 'SKU',
                title:t('order.sku'),
                dataIndex: 'sku',
                key: 'sku',
                width: '150',
                align: 'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                slotName:'sku',
            },
            // {
            //     // title: '车型',
            //     title:t('order.model'),
            //     dataIndex: 'model',
            //     key: 'model',
            //     width: '120',
            //     align: 'center',
            //     ellipsis:true,
            //     tooltip:true,
            //     show:true,
            // },
            // {
            //     // title: '品牌名称',
            //     title:t('order.brandName'),
            //     dataIndex: 'brand_name',
            //     key: 'brand_name',
            //     width: '150',
            //     align: 'center',
            //     ellipsis:true,
            //     tooltip:true,
            //     show:true,
            // },
            // {
            //     // title: '零件名称',
            //     title:t('order.partName'),
            //     dataIndex: 'part_name',
            //     key: 'part_name',
            //     width: '150',
            //     align: 'center',
            //     ellipsis:true,
            //     tooltip:true,
            //     show:true,
            // },
            {
                // title: '物料编码',
                title:t('order.inventoryCode'),
                dataIndex: 'inventory_code',
                key: 'inventory_code',
                width: '160',
                align: 'center',
                ellipsis:true,
                tooltip:true,
                show:true,
            },
            {
                // title: '车架号',
                title:t('order.frameNumber'),
                dataIndex: 'frame_number',
                key: 'frame_number',
                width: '160',
                align: 'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                slotName:'slot',
            },
            {
                // title: 'ERP行号',
                title:t('order.erpLineNo'),
                dataIndex: 'erp_line_no',
                key: 'erp_line_no',
                width: '130',
                align: 'center',
                ellipsis:true,
                tooltip:true,
                show:true,
            },
            {
                // title: '发货日期',
                title:t('returnExchange.deliveryDate'),
                dataIndex: 'delivery_date',
                key: 'delivery_date',
                width: '190',
                align: 'center',
                show:true,
            },
            {
                // title: '换货类型',
                title:t('returnExchange.swapType'),
                dataIndex: 'swap_type',
                key: 'swap_type',
                width: '150',
                align: 'center',
                show:false,
                slotName:'slot',
            },
            {
                // title: '已发货数量',
                title:t('order.shipQuantity'),
                dataIndex: 'ship_quantity',
                key: 'ship_quantity',
                width: '140',
                show:true,
                align: 'center',
            },
            {
                // title: '已退货数量',
                title:t('returnExchange.returnedQuantity'),
                dataIndex: 'back_number',
                key: 'back_number',
                width: '160',
                align: 'center',
                show:true,
            },
            {
                // title: '退货数量',
                title:t('returnExchange.backQuantity'),
                dataIndex: 'back_quantity',
                key: 'back_quantity',
                width: '120',
                align: 'center',
                show:true,
                slotName:'slot',
            },
            {
                // title: '换货数量',
                title:t('returnExchange.swapQuantity'),
                dataIndex: 'swap_quantity',
                key: 'swap_quantity',
                width: '150',
                align: 'center',
                show:false,
                slotName:'slot',
            },
            {
                // title: 'bom类别',
                title:t('returnExchange.bomCategory'),
                dataIndex: 'bom_category',
                key: 'bom_category',
                width: '270',
                align: 'center',
                show:false,
                slotName:'slot',
            },
            {
                // title: 'bom的换货物料编码',
                title:t('returnExchange.bom2'),
                dataIndex: 'bom',
                key: 'bom',
                width: '270',
                align: 'center',
                show:false,
                slotName:'slot',
            },
            {
                // title: '整车的换货物料编码',
                title:t('returnExchange.swapInventoryCode2'),
                dataIndex: 'swap_inventory_code',
                key: 'swap_inventory_code',
                width: '270',
                align: 'center',
                show:false,
                slotName:'slot',
            },
            {
                // title: '换货仓库',
                title:t('returnExchange.warehouse'),
                dataIndex: 'swap_inventory',
                key: 'swap_inventory',
                width: '270',
                align: 'center',
                show:false,
                slotName:'slot',
            },
            {
                // title: '库存',
                title:t('order.stockQuantity'),
                dataIndex: 'transaction_quantity',
                key: 'transaction_quantity',
                width: '120',
                align: 'center',
                show:false,
            },
            {
                // title: '备注',
                title:t('order.instruction'),
                dataIndex: 'instruction',
                key: 'instruction',
                width: '270',
                align: 'center',
                show:true,
                slotName:'slot',
            },
           
    ])
    const table = ref({
        datas:[],
        columns:columns.value,
        configs:{
            scroll:{
                // x:1000,
                y: 480
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            rowSelection:{
                type: 'checkbox',
                showCheckedAll: true,
                onlyCurrent: false,
            },
            selected:[],
            expandable:'',
            expand:false,
            pagination:false,
            
        },
    })
    const swapInventoryOptions = ref([])
    const swapInventoryCodeOptions = ref([])
    const bomCategoryOptions = ref([])
    const bomOptions = ref([])
    const swapTypeOptions = ref([
        {
            label:t('returnExchange.bike'),
            value:1,
            product_code: "627.501"
        },
        {
            label:t('returnExchange.bom'),
            value:2,
        }
    ])

    const init = ()=>{
        createReturnExchangeForm1.formField.forEach(i=>{
            if(i.key !== 'type' && i.key !== 'source'){
                createReturnExchangeForm1.formData[i.key] = ''
            }
        })
        createReturnExchangeForm2.formField.forEach(i=>{
            createReturnExchangeForm2.formData[i.key] = ''
        })
        createReturnExchangeForm3.formField.forEach(i=>{
            createReturnExchangeForm3.formData[i.key] = ''
            if(i.key == 'swap_courier_no'){
                i.required = false
            }
        })

        createReturnExchangeForm1.formData.source = rowData.value.source
        createReturnExchangeForm1.formData.source_val = rowData.value.source_val
        createReturnExchangeForm1.formData.order_id = rowData.value.id
        createReturnExchangeForm1.formData.erp_no = rowData.value.erp_no == '-'? '' : rowData.value.erp_no
        createReturnExchangeForm1.formData.customer_entity_id = rowData.value.customer_entity_id
        createReturnExchangeForm1.formData.customer_id = rowData.value.customer_id
        createReturnExchangeForm1.formData.customer_name = rowData.value.customer_name
        createReturnExchangeForm1.formData.customer_erp_code = rowData.value.customer_erp_code
        createReturnExchangeForm2.formData.file = ''

        let type_item = createReturnExchangeForm1.formField.find(i=> i.key == 'type')

        if(rowData.value.courier_status_val == 9 || rowData.value.courier_status_val == 10){ // 默认换货
            type_item.disabled = rowData.value.erp_no == '-'
            createReturnExchangeForm1.formData.type = 2
            createReturnExchangeForm1.formData.status = 2
            handleSelectChange(2,'','type')
        }else{
            createReturnExchangeForm1.formData.type = 1
            createReturnExchangeForm1.formData.status = 1
            type_item.disabled = false

            let item = createReturnExchangeForm1.formField.find(i=> i.key == 'discount')
            item.disabled = rowData.value.order_discount == '-'
            if(rowData.value.refund_discount == rowData.value.order_discount_val){
                createReturnExchangeForm1.formData.discount = 0
                item.disabled = true
            }else{
                item.disabled = false
            }

            let courier_no_item = createReturnExchangeForm2.formField.find(i=> i.key == 'courier_no')
            let courier_type = createReturnExchangeForm2.formField.find(i=> i.key == 'courier_type')
            let back_factory = createReturnExchangeForm2.formField.find(i=> i.key == 'back_factory')
            courier_no_item.required = true
            courier_type.required = true
            back_factory.required = true
            back_factory.show = true
            courier_no_item.disabled = true

            // 重置表格
            table.value.datas.forEach(i=>{
                if(createReturnExchangeForm1.formData.type == 1){
                    i.back_quantity = ''
                    i.instruction = ''
                }
            })

            tableRef.value.selectedKeys = []
            tableRef.value.selectedData = []

            settingColumn(createReturnExchangeForm1.formData.type)
        }
        

        // 换货
        if(createReturnExchangeForm1.formData.type == 2){
            table.value.datas.forEach(i=>{
                if(i.product_code == '627.501'){
                    i.swap_type = 'Bike'
                    changeSwapType('Bike', i)
                }else{
                    i.swap_type = 'Bom'
                    changeSwapType('Bom', i)
                }
            })
        }
    }

    const handleWidth = (type)=>{
        activeKey.value = type
        emits('handleReturnWidth',type)
    } 

    const handleSelectChange = (val,opt,key)=>{
        console.log(val,opt,key,'val,opt,item')
        if(key == 'type'){
            let courier_no_item = createReturnExchangeForm2.formField.find(i=> i.key == 'courier_no')
            let courier_type_item = createReturnExchangeForm2.formField.find(i=> i.key == 'courier_type')
            let back_factory_item = createReturnExchangeForm2.formField.find(i=> i.key == 'back_factory')
            courier_no_item.required = val == 1
            courier_type_item.required = val == 1
            back_factory_item.show = val == 1
            back_factory_item.required = val == 1

            if(val !== 2){
                createReturnExchangeForm3.formField.forEach(i=>{
                    createReturnExchangeForm3.formData[i.key] = ''
                })
            }else{
                getProductList()
                createReturnExchangeForm2.formData.courier_no = ''
                createReturnExchangeForm2.formData.courier_type = ''
                createReturnExchangeForm2.formData.back_factory = ''
                createReturnExchangeForm2.formData.back_courier_id = ''
                createReturnExchangeForm3.formData.swap_courier_id = ''
                courier_no_item.disabled = true
            }

            // 默认带出状态
            createReturnExchangeForm1.formData.status = val

            let swap_courier_no = createReturnExchangeForm3.formField.find(i=> i.key == 'swap_courier_no')
            swap_courier_no.disabled = true

            // 设置表格
            tableRef.value.selectedKeys = []
            tableRef.value.selectedData = []
            table.value.datas.forEach(i=>{
                i.swap_type = ''
                i.swap_type_val = ''
                i.back_quantity = ''
                i.swap_quantity = ''
                i.swap_inventory_code = ''
                i.swap_inventory = ''
                i.error = false
                i.bomDisabled = true
                i.swapInventoryCodeDisabled = true

                // 换货默认填充类型
                if(val == 2){
                    if(i.product_code == '627.501'){
                        i.swap_type = 'Bike'
                        changeSwapType('Bike', i)
                    }else{
                        i.swap_type = 'Bom'
                        changeSwapType('Bom', i)
                    }
                }else{
                    i.swap_type = ''
                }
            })
            settingColumn(val)
        }
    }

    const settingColumn = (val)=>{
        table.value.columns = []
        let arr = ['swap_type','bom_category','bom','swap_inventory_code','swap_inventory','swap_quantity','transaction_quantity']
        columns.value.forEach(i=>{
            if(arr.includes(i.key)){
                i.show = val == 2
            }
            if(i.show){
                table.value.columns.push(i)
            }
        })
    }

    const handleSelectDate = (val,date,item)=>{
        console.log(val,date,item,'val,date,item', props.row)
        
    }

    const handleInputNumber = (opt,val)=>{
        if(val > Number(rowData.value.order_discount_val) - Number(rowData.value.refund_discount)){
            Message.error(t('returnExchange.exceedingDiscount'))
        }
    }

    const handleInputChangeForm2 = (item,val)=>{
        // console.log(item,val,'val,opt,item7777')

        if(item.key == 'courier_no' && !!val){
            getCourierId()
        }else if(!val){
            createReturnExchangeForm2.formData.back_courier_id = ''
        }
    }

    const handleInputChangeForm3 = (item,val)=>{
        // console.log(item,val,'val,opt,item')
        if(item.key == 'swap_courier_no' && !!val){
            getSwapCourierId()
        }else if(!val){
            createReturnExchangeForm3.formData.swap_courier_id = ''
        }
    }

    const handleSelectChangeForm2 = (val,opt,key)=>{
        console.log(val,opt,key,'val,opt,key')
        if(key == 'courier_type'){
            let courierNoItem = createReturnExchangeForm2.formField.find(i=> i.key == 'courier_no')
            courierNoItem.required = !!createReturnExchangeForm2.formData.courier_type
            if(!!val && createReturnExchangeForm2.formData.courier_no === ''){
                courierNoItem.disabled = false
            }else if(!!val && createReturnExchangeForm2.formData.courier_no !== ''){
                getCourierId()
            }else{
                createReturnExchangeForm2.formData.courier_no = ''
                createReturnExchangeForm2.formData.back_courier_id = ''
                courierNoItem.disabled = true
            }
        }
    }

    const handleSelectChangeForm3 = (val,opt,key)=>{
        // console.log(val,opt,key,'val,opt,key222222')
        if(key == 'swap_courier_type'){
            let courierNoItem = createReturnExchangeForm3.formField.find(i=> i.key == 'swap_courier_no')
            courierNoItem.required = !!createReturnExchangeForm3.formData.swap_courier_type
            if(!!val && createReturnExchangeForm3.formData.swap_courier_no === ''){
                courierNoItem.disabled = false
            }else if(!!val && createReturnExchangeForm3.formData.swap_courier_no !== ''){
                getSwapCourierId()
            }else{
                createReturnExchangeForm3.formData.swap_courier_no = ''
                createReturnExchangeForm3.formData.swap_courier_id = ''
                courierNoItem.disabled = true
            }
        }
    }

    const selectRow = (val)=>{
        // console.log(val,'vb')
        selected.value = val
    }

    const selectRowAll = (val)=>{
        selected.value = val
    }

    const changeSwapType = (val,row)=>{
        // console.log(val, row, 'rrrrrr')
        let typeItem = swapTypeOptions.value.find(i=> i.label == val)
        row.swap_type_val = typeItem.value
        row.bomDisabled = typeItem.value == 1
        row.swapInventoryCodeDisabled = typeItem.value == 2

        // 重置bom、整车换货物料编码
        row.bom_category = ''
        row.bom = ''
        row.swap_inventory_code = ''
        row.transaction_quantity = ''

        if(row.swap_type_val == 2){
            swapInventoryOptions.value = swapInventoryOptions.value.filter(i=>{
                i.disabled = i.value != 'HFRM03' && i.value != 'HFRM05'
                return i
            })
        }else{
            swapInventoryOptions.value = swapInventoryOptions.value.filter(i=>{
                i.disabled = false
                return i
            })
        }

        let warehouseItem1 = swapInventoryOptions.value.find(i=> i.value == 'HFFG01') // 成品仓
        // let warehouseItem2 = swapInventoryOptions.value.find(i=> i.value == 'HFRM01') // 原材料仓
        let warehouseItem2 = swapInventoryOptions.value.find(i=> i.value == 'HFRM03') // 配件发货都只能从HFRM03和HFRM05 出
        row.swap_inventory = row.swap_type_val == 2? warehouseItem2.label : warehouseItem1.label
        row.swap_inventory_val = row.swap_type_val == 2? 'HFRM03' : 'HFFG01'

        // 重置为原来整车的sku和物料编码
        if(val == 'Bike' && row.bike_sku){
            row.sku = row.bike_sku 
            row.inventory_code = row.bike_inventory_code
        }

        // 控制物料编码字段显示/隐藏
        controlColumnShow(row)
    }

    // 控制物料编码字段显示/隐藏
    const controlColumnShow = (row)=>{
        let arr1 = [], arr2 = []
        table.value.datas.forEach(i=>{
            if(i.swap_type_val == 1){
                arr1.push(i)
            }
            if(i.swap_type_val == 2){
                arr2.push(i)
            }
        })

        let swap_inventory_code_item = columns.value.find(i=> i.key == 'swap_inventory_code')
        let bom_category_item = columns.value.find(i=> i.key == 'bom_category')
        let bom_item = columns.value.find(i=> i.key == 'bom')
        if((arr1.length == 0 && arr2.length == 0) || arr1.length > 0 && arr2.length > 0){
            swap_inventory_code_item.show = true
            bom_category_item.show = true
            bom_item.show = true
        }else if(arr1.length > 0 && arr2.length == 0){
            swap_inventory_code_item.show = true
            bom_category_item.show = false
            bom_item.show = false
        }else if(arr1.length == 0 && arr2.length > 0){
            swap_inventory_code_item.show = false
            bom_category_item.show = true
            bom_item.show = true
        }

        table.value.columns = []
        columns.value.forEach(i=>{
            if(i.show){
                table.value.columns.push(i)
            }
        })
    }

    const changeBomCategory = (val,row)=>{
        // console.log(val,row,'val,row')
        let code = val.split('|')[0].trim()
        row.bom = ''
        row.transaction_quantity = ''
        getBom(code, row)
    }

    const changeBom = (val,row)=>{
        // console.log(val, row, 'changeBom')
        let bomItem = row.bomOptions.length > 0? row.bomOptions.find(i=> i.label == val) : bomOptions.value.find(i=> i.label == val)
        if(row.swap_type_val == 2 && row.product_code == '627.501'){
            row.bike_sku = row.bike_sku? row.bike_sku : row.sku // 记录最开始的整车sku和物料编码
            row.bike_inventory_code = row.bike_inventory_code? row.bike_inventory_code : row.inventory_code
            row.sku = bomItem.sku
            row.inventory_code = bomItem.inventoryCode
        }
        getInventories(row.swap_inventory_val, val.split('|')[0].trim(), row)
    }

    const changeInventoryCode = (val,row)=>{
        // console.log(val,row,'mmmmmmmm111')
        let item = swapInventoryCodeOptions.value.find(i=> i.label == val)
        row.swap_inventory_code_val = item.value
        getInventories(row.swap_inventory_val, row.swap_inventory_code_val, row)
    }

    const changeInventory = (val,row)=>{
        // console.log(val,item,'mmmmmmmm111')
        let optItem = swapInventoryOptions.value.find(i=> i.label == val)
        row.swap_inventory_val = optItem.value

        if(row.swap_type_val == 1 && !!row.swap_inventory_code_val){
            getInventories(row.swap_inventory_val, row.swap_inventory_code_val,row)
        }
        if(row.swap_type_val == 2 && !!row.bom){
            getInventories(row.swap_inventory_val, row.bom.split('|')[0].trim(), row)
        }
    }

    const quantityChange = (val,row)=>{
        // console.log(val,row,'99999')
        row.error = row.back_number == undefined? val > row.ship_quantity : val > row.ship_quantity - row.back_number
        if(row.error){
            Message.error(t('returnExchange.exceedingQuantity'))
        }
    }

    // 上传中
    const changeUpload = (fileList)=>{
        let arr = []
        if(fileList.length > 0){
            fileList.forEach(i=>{
                if(i.status == 'done'){
                    arr.push(i.response.data)
                }
            })
        }
        createReturnExchangeForm2.formData.file = arr.join(',')
    }

    // 上传失败
    const errorUpload = (fileItem)=>{
        // console.log(fileItem,'失败')
        Message.error(t('returnExchange.uploadFail'))
    }

    // 获取订单行
    const getOrderLine = async (id,row)=>{
        let param = {
            order_id: id,
        }
        table.value.configs.loading = true
        let res = await OrderApi.getInstance().getStockOutList(param)
        if(res.code == 0){
            res.data.forEach(i=>{
                i.stock_out_id = i.id
                i.erp_line_no = i.erp_line_no == undefined? '-' : i.erp_line_no
                i.product_name = i.product_map == undefined? '-' : i.product_map.english_name
                // i.model = i.product_map == undefined? '-' : i.product_map.model == undefined? '-' : i.product_map.model 
                // i.brand_name = i.product_map == undefined? '-' : i.product_map.brand_name == undefined? '-' : i.product_map.brand_name 
                // i.part_name = i.product_map == undefined? '-' : i.product_map.part_name == undefined? '-' : i.product_map.part_name 
                i.inventory_code = i.inventory_code == undefined? '-' : i.inventory_code 
                i.quantity = i.quantity == undefined? '-' : i.quantity
                i.ship_quantity = i.ship_qty == undefined? '-' :i.ship_qty
                i.back_number = i.back_number == undefined? '-' : i.back_number
                i.swap_inventory_code = ''
                i.swap_inventory = ''
                i.swap_quantity = ''
                i.disabled = i.ship_qty == i.back_number // 是否允许勾选
                i.product_code = i.category_code
                i.frame_number = i.frame_number
                i.delivery_date = timestampToDate(i.delivery_date * 1000).split(' ')[0]
            })

            // 未取消出库的订单行
            table.value.datas = []
            res.data.forEach(i=>{
                if(i.status == 2){
                    table.value.datas.push(i)
                }
            })
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取原因类型
    const getReasonType = async ()=>{
        let res = await OrderApi.getInstance().getCourierType({dict_code: "order",dict_sub_code: "back_reason"})
        if(res.code == 0){
            let item = createReturnExchangeForm2.formField.find(i=> i.key == 'back_reason_type')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label:i.dict_sub_name,
                    value:i.dict_sub_value,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取IBS验证方案类型
    const getIBSVerificationType = async ()=>{
        let res = await OrderApi.getInstance().getCourierType({dict_code: "order",dict_sub_code: "IBS_verification_type"})
        if(res.code == 0){
            let item = createReturnExchangeForm2.formField.find(i=> i.key == 'ibs_verification_type')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label:i.dict_sub_name,
                    value:i.dict_sub_value,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取物流公司
    const getCourierType = async ()=>{
        let res = await OrderApi.getInstance().getCourierType({dict_code: "courier_back"})
        if(res.code == 0){
            let item = createReturnExchangeForm2.formField.find(i=> i.key == 'courier_type')
            let item2 = createReturnExchangeForm3.formField.find(i=> i.key == 'swap_courier_type')
            item.options = []
            item2.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label: i.dict_sub_name,
                    value: i.dict_sub_value,
                })
                item2.options.push({
                    label: i.dict_sub_name,
                    value: i.dict_sub_value,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取退货物流id
    const getCourierId = async ()=>{
        let param = {
            courier_type: createReturnExchangeForm2.formData.courier_type,
            courier_no: createReturnExchangeForm2.formData.courier_no,
        }
        let res = await OrderApi.getInstance().getCourierId(param)
        if(res.code == 0){
            createReturnExchangeForm2.formData.back_courier_id = res.data.id
        }else{
            Message.error(res.msg)
        }
    }

    // 获取换货物流id
    const getSwapCourierId = async ()=>{
        let param = {
            courier_type: createReturnExchangeForm3.formData.swap_courier_type,
            courier_no: createReturnExchangeForm3.formData.swap_courier_no,
        }
        let res = await OrderApi.getInstance().getCourierId(param)
        if(res.code == 0){
            createReturnExchangeForm3.formData.swap_courier_id = res.data.id
        }else{
            Message.error(res.msg)
        }
    }

    // 获取仓库
    const getWarehouse = async ()=>{
        let res = await OrderApi.getInstance().getWarehouse()
        if(res.code == 0){
            swapInventoryOptions.value = []
            res.data.length > 0 && res.data.forEach(i=>{
                swapInventoryOptions.value.push({
                    label: `${i.description} (${i.subinventory_name})`,
                    value: i.subinventory_name,
                    disabled: i.subinventory_name == 'HFFG05',
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取产品列表,拿到换货物料编码下拉数据
    const getProductList = async ()=>{
        let res = await OrderApi.getInstance().getProductList({})
        if(res.code == 0){
            swapInventoryCodeOptions.value = []
            res.data.length > 0 && res.data.forEach(i=>{
                if(i.category_code !== undefined && i.category_code == '627.501'){
                    let model = i.model == undefined? 'null' : i.model
                    let modelYear = i.model_year == undefined? 'null' : i.model_year
                    let brandName = i.brand_name == undefined? 'null' : i.brand_name
                    let partName = i.part_name == undefined? 'null' : i.part_name
                    swapInventoryCodeOptions.value.push({
                        label: i.english_name == undefined? i.sku : `${i.sku} | ${i.english_name} | ${model} | ${modelYear} | ${brandName} | ${partName}`,
                        value: i.inventory_code
                    })
                }
            })
        }else{
            Message.error(res.msg)
        }
    }

     // 获取bom类别
     const getBomCategory = async ()=>{
        let res = await OrderApi.getInstance().getBomCategory()
        if(res.code == 0){
            bomCategoryOptions.value = []
            res.data.forEach(i=>{
                if(i.CATEGORY_CODE !== undefined && i.CATEGORY_CODE !== '627.501' && i.CATEGORY_CODE !== '627.502'){
                    bomCategoryOptions.value.push({
                        label: `${i.CATEGORY_CODE} | ${i.CATEGORY_NAME}`,
                        value: i.CATEGORY_CODE
                    })
                }
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取bom
    const getBom = async (code, row)=>{
        let param = {}
        if(code) param.category_code = code
        if(row) row.loading = true
        let res = await OrderApi.getInstance().getBom(param)
        if(res.code == 0){
            bomOptions.value = []
            res.data.forEach(i=>{
                if(i.category_code != '627.501'){
                    let brandName = i.brand_name == undefined? 'null' : i.brand_name
                    let partName = i.part_name == undefined? 'null' : i.part_name
                    bomOptions.value.push({
                        label: `${i.inventory_code} | ${i.english_name} | ${brandName} | ${partName}`,
                        value: i.inventory_code,
                        sku:i.sku,
                        inventoryCode: i.inventory_code,
                    })
                }
            })

            if(row){
                row.bomOptions = bomOptions.value
                row.loading = false
            }else{
                table.value.datas.forEach(i=>{
                    i.bomOptions = bomOptions.value
                })
            }
        }else{
            Message.error(res.msg)
        }
    }

    // 根据仓库查库存
    const getInventories = async (warehouse,inventoryCode,row)=>{
        let param = {
            inventory_codes: inventoryCode,
            warehouse: warehouse,
        }
        let res = await OrderApi.getInstance().getInventories(param)
        if(res.code == 0){
            if(res.data && res.data.length > 0){
                res.data.forEach(c=>{
                    if(inventoryCode == c.item_number){
                        row.transaction_quantity = c.transaction_quantity
                    }
                })
            }else{
                row.transaction_quantity = 0
            }   
        }else{
            Message.error(res.msg)
        }
    }
   

    watch(()=>props.row,(nVal,oVal)=>{
        rowData.value = nVal
    })
    watch(()=>props.visible,async (nVal,oVal)=>{
        rowData.value = props.row
        order_name.value = props.row.order_name
        getReasonType()
        getIBSVerificationType()
        getCourierType()
        getWarehouse()
        getBomCategory()
        getBom()
        await getOrderLine(rowData.value.id, rowData.value)
        init()
    })

    defineExpose({
        rowData,
        createForm,
        createReturnExchangeForm1,
        createReturnExchangeForm2,
        createReturnExchangeForm3,
        selected
    })

    onMounted(()=>{
        
    })
</script>

<style lang="less" scoped>
.returnForm{
    min-width: 70%;
    max-width:75%;
    margin:0 auto;
    padding:20px;

    /deep/ .arco-form{
        display: block;
        text-align: center;
    }

    /deep/ .arco-input-wrapper .arco-input{
        height: 30px;
        width:100%;
    }

    /deep/ .arco-select,
    /deep/ .arco-textarea,
    /deep/ .arco-picker{
        height: 40px;
    }
}

/deep/ .arco-table-th{
    background-color: #333 !important;
    color: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    padding: 0;
    font-weight: 300;
    font-size:12px;
}

.uploadImg{
    /deep/ .arco-form-item-content-flex{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-top: 8px;
        margin-left: 20px;
    }
}
.uploadDesc{
    margin-bottom: 3px;
    font-size: 12px;
    color: #4d83ff;
}   
</style>